import { SVGProps } from 'react'

export const CardSliderFooterBorderIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="217.25rem"
      height="34rem"
      viewBox="63 0 217.25 34"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_d_2340_6905)">
        <path
          d="M63 0L81.1025 26.1151C84.0917 30.4274 89.0052 33 94.2522 33H248.998C254.245 33 259.158 30.4274 262.147 26.1151L280.25 0"
          stroke="url(#paint0_linear_2340_6905)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2340_6905"
          x="-31.4109"
          y="-39"
          width="406.072"
          height="221.785"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="18" />
          <feGaussianBlur stdDeviation="47" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2340_6905"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2340_6905"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2340_6905"
          x1="171.125"
          y1="0"
          x2="171.125"
          y2="74"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
      </defs>
    </svg>
  )
}
